const SOURCE = "Pathfinder RPG Core Rulebook";
const ENGLISH_REFERENCE_URL = "https://www.aonprd.com/FeatDisplay.aspx";

const COMBAT_FEATS = [
  "Agile Maneuvers", "Arcane Armor Training", "Arcane Armor Mastery", "Arcane Strike", "Armor Proficiency, Light", "Armor Proficiency, Medium", "Armor Proficiency, Heavy", "Blind-Fight", "Catch Off-Guard", "Channel Smite", "Combat Expertise", "Combat Reflexes", "Critical Focus", "Bleeding Critical", "Blinding Critical", "Critical Mastery", "Deafening Critical", "Sickening Critical", "Staggering Critical", "Stunning Critical", "Tiring Critical", "Exhausting Critical", "Deadly Aim", "Defensive Combat Training", "Disruptive", "Spellbreaker", "Dodge", "Mobility", "Spring Attack", "Wind Stance", "Lightning Stance", "Exotic Weapon Proficiency", "Improved Critical", "Improved Initiative", "Improved Unarmed Strike", "Deflect Arrows", "Snatch Arrows", "Improved Grapple", "Greater Grapple", "Scorpion Style", "Gorgon's Fist", "Medusa's Wrath", "Stunning Fist", "Improvised Weapon Mastery", "Intimidating Prowess", "Lunge", "Martial Weapon Proficiency", "Mounted Combat", "Mounted Archery", "Ride-By Attack", "Spirited Charge", "Trample", "Unseat", "Nimble Moves", "Acrobatic Steps", "Point-Blank Shot", "Far Shot", "Precise Shot", "Improved Precise Shot", "Pinpoint Targeting", "Shot on the Run", "Rapid Shot", "Manyshot", "Power Attack", "Cleave", "Great Cleave", "Improved Bull Rush", "Greater Bull Rush", "Improved Overrun", "Greater Overrun", "Improved Sunder", "Greater Sunder", "Quick Draw", "Rapid Reload", "Shield Proficiency", "Improved Shield Bash", "Shield Slam", "Shield Master", "Shield Focus", "Greater Shield Focus", "Tower Shield Proficiency", "Simple Weapon Proficiency", "Step Up", "Strike Back", "Throw Anything", "Two-Weapon Fighting", "Double Slice", "Two-Weapon Rend", "Improved Two-Weapon Fighting", "Greater Two-Weapon Fighting", "Two-Weapon Defense", "Vital Strike", "Improved Vital Strike", "Greater Vital Strike", "Weapon Finesse", "Weapon Focus", "Dazzling Display", "Shatter Defenses", "Deadly Stroke", "Greater Weapon Focus", "Penetrating Strike", "Greater Penetrating Strike", "Weapon Specialization", "Greater Weapon Specialization",
];

const GENERAL_FEATS = [
  "Acrobatic", "Alertness", "Alignment Channel", "Animal Affinity", "Athletic", "Augment Summoning", "Combat Casting", "Command Undead", "Deceitful", "Deft Hands", "Elemental Channel", "Endurance", "Diehard", "Eschew Materials", "Extra Channel", "Extra Ki", "Extra Lay On Hands", "Extra Mercy", "Extra Performance", "Extra Rage", "Fleet", "Great Fortitude", "Improved Great Fortitude", "Improved Channel", "Improved Counterspell", "Improved Familiar", "Iron Will", "Improved Iron Will", "Leadership", "Lightning Reflexes", "Improved Lightning Reflexes", "Magical Aptitude", "Master Craftsman", "Natural Spell", "Persuasive", "Run", "Selective Channeling", "Self-Sufficient", "Skill Focus", "Spell Focus", "Greater Spell Focus", "Spell Mastery", "Spell Penetration", "Greater Spell Penetration", "Stealthy", "Toughness", "Turn Undead",
];

const ITEM_CREATION_FEATS = ["Brew Potion", "Craft Magic Arms and Armor", "Craft Rod", "Craft Staff", "Craft Wand", "Craft Wondrous Item", "Forge Ring", "Scribe Scroll"];
const METAMAGIC_FEATS = ["Empower Spell", "Enlarge Spell", "Extend Spell", "Heighten Spell", "Maximize Spell", "Quicken Spell", "Silent Spell", "Still Spell", "Widen Spell"];

const DETAILS = {
  "Critical Focus": { prerequisites: "Base attack bonus +9", description: "+4 bonus on attack rolls to confirm critical hits." },
  "Improved Initiative": { prerequisites: "None", description: "+4 bonus on initiative checks." },
  "Weapon Finesse": { prerequisites: "None", description: "Use Dexterity instead of Strength on attack rolls with eligible light weapons." },
  "Power Attack": { prerequisites: "Strength 13, base attack bonus +1", description: "Trade melee attack bonus for additional damage." },
  "Combat Expertise": { prerequisites: "Intelligence 13", description: "Trade attack bonus for an Armor Class bonus." },
  "Point-Blank Shot": { prerequisites: "None", description: "+1 on ranged attack and damage rolls within 30 feet." },
  "Precise Shot": { prerequisites: "Point-Blank Shot", description: "Ignore the penalty for firing into melee." },
  "Rapid Shot": { prerequisites: "Dexterity 13, Point-Blank Shot", description: "Make one extra ranged attack with a penalty." },
  "Dodge": { prerequisites: "Dexterity 13", description: "+1 dodge bonus to Armor Class." },
  "Toughness": { prerequisites: "None", description: "Gain additional hit points." },
  "Combat Reflexes": { prerequisites: "None", description: "Make additional attacks of opportunity based on Dexterity." },
  "Spell Focus": { prerequisites: "None", description: "+1 to saving throw DCs for one school of magic." },
  "Spell Penetration": { prerequisites: "None", description: "+2 on caster level checks to overcome spell resistance." },
};

const LOCALIZED_FEATS = {
  "agile-maneuvers": {
    "name": "Ловкий маневр",
    "prerequisites": "",
    "description": "При подсчете МБМ учитывается модификатор Ловкости",
    "referenceUrl": "https://pathfinder.family/feat/agileManeuvers"
  },
  "arcane-armor-training": {
    "name": "Мистический доспех",
    "prerequisites": "Ношение легкой брони, УЗ 3",
    "description": "Вероятность провала заклинания из-за надетых доспехов уменьшается на 10%",
    "referenceUrl": "https://pathfinder.family/feat/arcaneArmorTraining"
  },
  "arcane-armor-mastery": {
    "name": "Мистический доспех+",
    "prerequisites": "Мистический доспех, Ношение средней брони,УЗ 7",
    "description": "Вероятность провала заклинания из-за надетых доспехов уменьшается на 20%",
    "referenceUrl": "https://pathfinder.family/feat/arcaneArmorMastery"
  },
  "arcane-strike": {
    "name": "Волшебный удар",
    "prerequisites": "Способность творить мистические заклинания",
    "description": "+1 к урону, оружие считается магическим",
    "referenceUrl": "https://pathfinder.family/feat/arcaneStrike"
  },
  "armor-proficiency-light": {
    "name": "Ношение легкой брони",
    "prerequisites": "",
    "description": "Вы не получаете штрафов к атакам в легкой броне",
    "referenceUrl": "https://pathfinder.family/feat/armorProficiencyLight"
  },
  "armor-proficiency-medium": {
    "name": "Ношение средней брони",
    "prerequisites": "Ношение легкой брони",
    "description": "Вы не получаете штрафов к атакам в средней броне",
    "referenceUrl": "https://pathfinder.family/feat/armorProficiencyMedium"
  },
  "armor-proficiency-heavy": {
    "name": "Ношение тяжелой брони",
    "prerequisites": "Ношение средней брони",
    "description": "Вы не получаете штрафов к атакам в тяжелой броне",
    "referenceUrl": "https://pathfinder.family/feat/armorProficiencyHeavy"
  },
  "blind-fight": {
    "name": "Бой вслепую",
    "prerequisites": "",
    "description": "Переброс вероятности промаха из-за плохой видимости цели",
    "referenceUrl": "https://pathfinder.family/feat/blindFight"
  },
  "catch-off-guard": {
    "name": "Мастер импровизации",
    "prerequisites": "",
    "description": "Вы не получаете штрафов при атаке импровизированным оружием",
    "referenceUrl": "https://pathfinder.family/feat/catchOffGuard"
  },
  "channel-smite": {
    "name": "Проводящий удар",
    "prerequisites": "Классовая особенность, позволяющая проводить энергию",
    "description": "Вы наполняете свой удар энергией",
    "referenceUrl": "https://pathfinder.family/feat/channelSmite"
  },
  "combat-expertise": {
    "name": "Защитная стойка",
    "prerequisites": "Инт 13",
    "description": "Обмен точности атаки на более высокий КБ",
    "referenceUrl": "https://pathfinder.family/feat/combatExpertise"
  },
  "combat-reflexes": {
    "name": "Боевые рефлексы",
    "prerequisites": "",
    "description": "Больше внеочередных атак",
    "referenceUrl": "https://pathfinder.family/feat/combatReflexes"
  },
  "critical-focus": {
    "name": "Критическая точность",
    "prerequisites": "БМА +9",
    "description": "+4 к подтверждению критических ударов",
    "referenceUrl": "https://pathfinder.family/feat/criticalFocus"
  },
  "bleeding-critical": {
    "name": "Критическое кровотечение",
    "prerequisites": "Критическая точность, БМА +11",
    "description": "От вашего критического удара противник истекает кровью (2d6)",
    "referenceUrl": "https://pathfinder.family/feat/bleedingCritical"
  },
  "blinding-critical": {
    "name": "Критическое ослепление",
    "prerequisites": "Критическая точность, БМА +15",
    "description": "От вашего критического удара противник слепнет",
    "referenceUrl": "https://pathfinder.family/feat/blindingCritical"
  },
  "critical-mastery": {
    "name": "Мастер критических ударов",
    "prerequisites": "Любые две критических черты, 14 уровень воина",
    "description": "Ваши критические удары дают два эффекта сразу",
    "referenceUrl": "https://pathfinder.family/feat/criticalMastery"
  },
  "deafening-critical": {
    "name": "Критическое оглушение",
    "prerequisites": "Критическая точность, БМА +13",
    "description": "Ваши критические удары оглушают противников",
    "referenceUrl": "https://pathfinder.family/feat/deafeningCritical"
  },
  "sickening-critical": {
    "name": "Критическая дезориентация",
    "prerequisites": "Критическая точность, БМА +11",
    "description": "Ваши критические удары дезориентируют противников",
    "referenceUrl": "https://pathfinder.family/feat/sickeningCritical"
  },
  "staggering-critical": {
    "name": "Критическое ошеломление",
    "prerequisites": "Критическая точность, БМА +13",
    "description": "Ваши критические удары ошеломляют противников",
    "referenceUrl": "https://pathfinder.family/feat/staggeringCritical"
  },
  "stunning-critical": {
    "name": "Критический шок",
    "prerequisites": "Критическое ошеломление, БМА +17",
    "description": "Ваши критические удары повергают противников в шок",
    "referenceUrl": "https://pathfinder.family/feat/stunningCritical"
  },
  "tiring-critical": {
    "name": "Критическое утомление",
    "prerequisites": "Критическая точность, БМА +13",
    "description": "Ваши критические удары утомляют противников",
    "referenceUrl": "https://pathfinder.family/feat/tiringCritical"
  },
  "exhausting-critical": {
    "name": "Критическое обессиливание",
    "prerequisites": "Критическое утомление, БМА +15",
    "description": "Ваши критические удары обессиливают противников",
    "referenceUrl": "https://pathfinder.family/feat/exhaustingCritical"
  },
  "deadly-aim": {
    "name": "Убийственная меткость",
    "prerequisites": "Лвк 13, БМА +1",
    "description": "Обмен точности атаки на более высокий урон",
    "referenceUrl": "https://pathfinder.family/feat/deadlyAim"
  },
  "defensive-combat-training": {
    "name": "Самооборона",
    "prerequisites": "",
    "description": "Для расчета ЗБМ ваш БМА считается равным количеству ваших КЗ",
    "referenceUrl": "https://pathfinder.family/feat/defensiveCombatTraining"
  },
  "disruptive": {
    "name": "Помеха для заклинаний",
    "prerequisites": "6 уровень воина",
    "description": "Рядом с вами труднее творить заклинания",
    "referenceUrl": "https://pathfinder.family/feat/disruptive"
  },
  "spellbreaker": {
    "name": "Разрушитель заклинаний",
    "prerequisites": "Помеха для заклинаний, 10 уровень воина",
    "description": "Заклинатели рядом с вами провоцируют внеочередные атаки",
    "referenceUrl": "https://pathfinder.family/feat/spellbreaker"
  },
  "dodge": {
    "name": "Уворот",
    "prerequisites": "Лвк 13",
    "description": "+1 (уклонение) к КБ",
    "referenceUrl": "https://pathfinder.family/feat/dodge"
  },
  "mobility": {
    "name": "Подвижность",
    "prerequisites": "Уворот",
    "description": "+4 КБ от внеочердных атак при перемещении",
    "referenceUrl": "https://pathfinder.family/feat/mobility"
  },
  "spring-attack": {
    "name": "Удар на проходе",
    "prerequisites": "Подвижность, БМА +4",
    "description": "Вы перемещаетесь до и после атаки в ближнем бою",
    "referenceUrl": "https://pathfinder.family/feat/springAttack"
  },
  "wind-stance": {
    "name": "Стремительность",
    "prerequisites": "Уворот, Лвк 15, БМА +6",
    "description": "Когда вы движетесь, противник атакует вас с вероятностью промаха 20%",
    "referenceUrl": "https://pathfinder.family/feat/windStance"
  },
  "lightning-stance": {
    "name": "Стремительность+",
    "prerequisites": "Стремительность, Лвк 17, БМА +11",
    "description": "Когда вы движетесь, противник атакует вас с вероятностью промаха 50%",
    "referenceUrl": "https://pathfinder.family/feat/lightningStance"
  },
  "exotic-weapon-proficiency": {
    "name": "Обращение с экзотическим оружием",
    "prerequisites": "БМА +1",
    "description": "Нет штрафов к атакам одним видом экзотического оружия",
    "referenceUrl": "https://pathfinder.family/feat/exoticWeaponProficiency"
  },
  "improved-critical": {
    "name": "Улучшенный критический удар",
    "prerequisites": "Обращение с оружием, БМА +8",
    "description": "Удвоение критического диапазона одного вида оружия",
    "referenceUrl": "https://pathfinder.family/feat/improvedCritical"
  },
  "improved-initiative": {
    "name": "Улучшенная инициатива",
    "prerequisites": "",
    "description": "+4 к проверкам инициативы",
    "referenceUrl": "https://pathfinder.family/feat/improvedInitiative"
  },
  "improved-unarmed-strike": {
    "name": "Мастер кулачного боя",
    "prerequisites": "",
    "description": "Вы всегда считаетесь вооруженным",
    "referenceUrl": "https://pathfinder.family/feat/improvedUnarmedStrike"
  },
  "deflect-arrows": {
    "name": "Отбивание стрел",
    "prerequisites": "Мастер кулачного боя, Лвк 13",
    "description": "Вы отбиваете одну дистанционную атаку в раунд",
    "referenceUrl": "https://pathfinder.family/feat/deflectArrows"
  },
  "snatch-arrows": {
    "name": "Ловля стрел",
    "prerequisites": "Отбивание стрел, Лвк 15",
    "description": "Вы ловите один снаряд, выпущенный из дистанционного оружия, в раунд",
    "referenceUrl": "https://pathfinder.family/feat/snatchArrows"
  },
  "improved-grapple": {
    "name": "Захват+",
    "prerequisites": "Мастер кулачного боя, Лвк 13",
    "description": "+2 к попыткам захвата, не провоцирует внеочередную атаку",
    "referenceUrl": "https://pathfinder.family/feat/improvedGrapple"
  },
  "greater-grapple": {
    "name": "Захват++",
    "prerequisites": "Захват+, БМА +6",
    "description": "Поддержание захвата - сопутствующее действие",
    "referenceUrl": "https://pathfinder.family/feat/greaterGrapple"
  },
  "scorpion-style": {
    "name": "Стиль скорпиона",
    "prerequisites": "Мастер кулачного боя",
    "description": "Снижаете скорость противника до 5 футов",
    "referenceUrl": "https://pathfinder.family/feat/scorpionStyle"
  },
  "gorgon-s-fist": {
    "name": "Кулак горгоны",
    "prerequisites": "Стиль скорпиона, БМА +6",
    "description": "Ошеломляете противника, у которого снижена скорость",
    "referenceUrl": "https://pathfinder.family/feat/gorgonsFist"
  },
  "medusa-s-wrath": {
    "name": "Гнев медузы",
    "prerequisites": "Кулак горгоны, БМА +11",
    "description": "Две дополнительные атаки по противнику в негативном состоянии",
    "referenceUrl": "https://pathfinder.family/feat/nedusasWrath"
  },
  "stunning-fist": {
    "name": "Шокирующий кулак",
    "prerequisites": "Мастер кулачного боя, Лвк 13, Мдр 13, БМА +8",
    "description": "Ваши атаки без оружия повергают врагов в шок",
    "referenceUrl": "https://pathfinder.family/feat/stunningFist"
  },
  "improvised-weapon-mastery": {
    "name": "Смертоносная импровизация",
    "prerequisites": "БМА +8, Мастер импровизации или Универсальный метатель",
    "description": "Импровизированное оружие становится смертоносным",
    "referenceUrl": "https://pathfinder.family/feat/improvisedWeaponMastery"
  },
  "intimidating-prowess": {
    "name": "Внушительный вид",
    "prerequisites": "",
    "description": "Добавление модификатора Силы к проверкам Запугивания",
    "referenceUrl": "https://pathfinder.family/feat/intimidatingProwess"
  },
  "lunge": {
    "name": "Выпад",
    "prerequisites": "БМА +6",
    "description": "-2 к КБ, чтобы увеличить зону досягаемости атаки",
    "referenceUrl": "https://pathfinder.family/feat/lunge"
  },
  "martial-weapon-proficiency": {
    "name": "Обращение с особым оружием",
    "prerequisites": "",
    "description": "Нет штрафов к атакам одним видом особого оружия",
    "referenceUrl": "https://pathfinder.family/feat/martialWeaponProficiency"
  },
  "mounted-combat": {
    "name": "Бой верхом",
    "prerequisites": "1 пункт в Верховой езде",
    "description": "Уклонение от атак проверкой Верховой езды",
    "referenceUrl": "https://pathfinder.family/feat/mountedCombat"
  },
  "mounted-archery": {
    "name": "Верховой лучник",
    "prerequisites": "Бой верхом",
    "description": "Штраф за дистанционную атаку верхом уменьшается вдвое",
    "referenceUrl": "https://pathfinder.family/feat/mountedArchery"
  },
  "ride-by-attack": {
    "name": "Удар на скаку",
    "prerequisites": "Бой верхом",
    "description": "Атака в процессе перемещения верхом",
    "referenceUrl": "https://pathfinder.family/feat/rideByAttack"
  },
  "spirited-charge": {
    "name": "Лихой натиск",
    "prerequisites": "Удар на скаку",
    "description": "Двойной урон при атаке с разбега верхом",
    "referenceUrl": "https://pathfinder.family/feat/spiritedCharge"
  },
  "trample": {
    "name": "Затаптывание",
    "prerequisites": "Бой верхом",
    "description": "Затаптывание противника скакуном",
    "referenceUrl": "https://pathfinder.family/feat/trample"
  },
  "unseat": {
    "name": "Выбивание из седла",
    "prerequisites": "Таран+, Бой верхом",
    "description": "Выбивание противника из седла",
    "referenceUrl": "https://pathfinder.family/feat/unseat"
  },
  "nimble-moves": {
    "name": "Легкая поступь",
    "prerequisites": "Лвк 13",
    "description": "При движении вы игнорируете до 5 футов пересеченной местности",
    "referenceUrl": "https://pathfinder.family/feat/nimbleMoves"
  },
  "acrobatic-steps": {
    "name": "Легкая поступь+",
    "prerequisites": "Легкая поступь, Лвк 15",
    "description": "При движении вы игнорируете до 20 футов пересеченной местности",
    "referenceUrl": "https://pathfinder.family/feat/acrobaticSteps"
  },
  "point-blank-shot": {
    "name": "Стрельба вблизи",
    "prerequisites": "",
    "description": "+1 к атакам и урону по целям в радиусе 30 футов от вас",
    "referenceUrl": "https://pathfinder.family/feat/pointBlankShot"
  },
  "far-shot": {
    "name": "Дальний выстрел",
    "prerequisites": "Стрельба вблизи",
    "description": "Снижение штрафа за шаг дистанции",
    "referenceUrl": "https://pathfinder.family/feat/farShot"
  },
  "precise-shot": {
    "name": "Прицельная стрельба",
    "prerequisites": "Стрельба вблизи",
    "description": "Нет штрафов за стрельбу по противникам, вовлеченным в ближний бой",
    "referenceUrl": "https://pathfinder.family/feat/preciseShot"
  },
  "improved-precise-shot": {
    "name": "Прицельная стрельба+",
    "prerequisites": "Прицельная стрельба, Лвк 19, БМА +11",
    "description": "От выстрела не защищает укрытие и плохая видимость",
    "referenceUrl": "https://pathfinder.family/feat/improvedPreciseShot"
  },
  "pinpoint-targeting": {
    "name": "Тщательное прицеливание",
    "prerequisites": "Прицельная стрельба+, БМА +16",
    "description": "От выстрела не защищают доспехи и щиты",
    "referenceUrl": "https://pathfinder.family/feat/pinpointTargeting"
  },
  "shot-on-the-run": {
    "name": "Выстрел на бегу",
    "prerequisites": "Стрельба вблизи, Подвижность, Лвк 13, БМА +4",
    "description": "Дистанционная атака в любой момент перемещения",
    "referenceUrl": "https://pathfinder.family/feat/shotOnTheRun"
  },
  "rapid-shot": {
    "name": "Быстрый выстрел",
    "prerequisites": "Стрельба вблизи, Лвк 13",
    "description": "Дополнительная дистанционная атака",
    "referenceUrl": "https://pathfinder.family/feat/rapidShot"
  },
  "manyshot": {
    "name": "Залп",
    "prerequisites": "Быстрый выстрел, Лвк 17, БМА +6",
    "description": "Выстрел двумя стрелами одновременно",
    "referenceUrl": "https://pathfinder.family/feat/manyshot"
  },
  "power-attack": {
    "name": "Сокрушительный удар",
    "prerequisites": "Сил 13, БМА +1",
    "description": "Штраф к атаке, но более высокий урон при попадании",
    "referenceUrl": "https://pathfinder.family/feat/powerAttack"
  },
  "cleave": {
    "name": "Бойня",
    "prerequisites": "Сокрушительный удар",
    "description": "Дополнительная атака после одной успешной",
    "referenceUrl": "https://pathfinder.family/feat/cleave"
  },
  "great-cleave": {
    "name": "Бойня+",
    "prerequisites": "Бойня, БМА +4",
    "description": "Дополнительная атака после каждой успешной",
    "referenceUrl": "https://pathfinder.family/feat/greatCleave"
  },
  "improved-bull-rush": {
    "name": "Таран+",
    "prerequisites": "Сокрушительный удар",
    "description": "+2 к попыткам тарана, не провоцируете внеочередных атак",
    "referenceUrl": "https://pathfinder.family/feat/improvedBullRush"
  },
  "greater-bull-rush": {
    "name": "Таран++",
    "prerequisites": "Таран+, БМА +6",
    "description": "Враги, которых вы тараните, провоцируют внеочередные атаки",
    "referenceUrl": "https://pathfinder.family/feat/greaterBullRush"
  },
  "improved-overrun": {
    "name": "Вторжение+",
    "prerequisites": "Сокрушительный удар",
    "description": "+2 к попыткам вторжения, не провоцируете внеочередных атак",
    "referenceUrl": "https://pathfinder.family/feat/improvedOverrun"
  },
  "greater-overrun": {
    "name": "Вторжение++",
    "prerequisites": "Вторжение+, БМА +6",
    "description": "Враги, к которым вы вторгаетесь, провоцируют внеочередные атаки",
    "referenceUrl": "https://pathfinder.family/feat/greaterOverrun"
  },
  "improved-sunder": {
    "name": "Разрушение+",
    "prerequisites": "Сокрушительный удар",
    "description": "+2 к попыткам разрушения, не провоцируете внеочередных атак",
    "referenceUrl": "https://pathfinder.family/feat/improvedSunder"
  },
  "greater-sunder": {
    "name": "Разрушение++",
    "prerequisites": "Разрушение+, БМА +6",
    "description": "Лишний урон от разрушения приходится по врагу",
    "referenceUrl": "https://pathfinder.family/feat/greaterSunder"
  },
  "quick-draw": {
    "name": "Быстрое выхватывание",
    "prerequisites": "БМА +1",
    "description": "Вы выхватываете оружие в качестве свободного действия",
    "referenceUrl": "https://pathfinder.family/feat/quickDraw"
  },
  "rapid-reload": {
    "name": "Быстрая перезарядка",
    "prerequisites": "Оращение с оружием (арбалет)",
    "description": "Быстрая перезарядка арбалета",
    "referenceUrl": "https://pathfinder.family/feat/rapidReload"
  },
  "shield-proficiency": {
    "name": "Обращение со щитом",
    "prerequisites": "",
    "description": "Нет штрафов к атакам при использовании щита",
    "referenceUrl": "https://pathfinder.family/feat/shieldProficiency"
  },
  "improved-shield-bash": {
    "name": "Удар щитом+",
    "prerequisites": "Обращение со щитом",
    "description": "При атаке щитом вы сохраняете бонус щита",
    "referenceUrl": "https://pathfinder.family/feat/improvedShieldBash"
  },
  "shield-slam": {
    "name": "Таран щитом",
    "prerequisites": "Удар щитом+, Парное оружие, БМА +6",
    "description": "Возможна попытка протаранить противника при ударе щитом",
    "referenceUrl": "https://pathfinder.family/feat/shieldSlam"
  },
  "shield-master": {
    "name": "Мастер щита",
    "prerequisites": "Таран щитом, БМА +11",
    "description": "Нет штрафов за бой парным оружием при атаке щитом",
    "referenceUrl": "https://pathfinder.family/feat/shieldMaster"
  },
  "shield-focus": {
    "name": "Уверенное владение щитом",
    "prerequisites": "Обращение со щитом, БМА +1",
    "description": "+1 к КБ при использовании щита",
    "referenceUrl": "https://pathfinder.family/feat/shieldFocus"
  },
  "greater-shield-focus": {
    "name": "Уверенное владение щитом+",
    "prerequisites": "Уверенное владение щитом, 8 уровень воина",
    "description": "+1 к КБ при использовании щита",
    "referenceUrl": "https://pathfinder.family/feat/greaterShieldFocus"
  },
  "tower-shield-proficiency": {
    "name": "Обращение с башенным щитом",
    "prerequisites": "Обращение со щитом",
    "description": "Нет штрафов к атакам при использовании башенного щита",
    "referenceUrl": "https://pathfinder.family/feat/towerShieldProficiency"
  },
  "simple-weapon-proficiency": {
    "name": "Обращение с простым оружием",
    "prerequisites": "",
    "description": "Нет штрафов к атакам любым простым оружием",
    "referenceUrl": "https://pathfinder.family/feat/simpleWeaponProficiency"
  },
  "step-up": {
    "name": "Преграда",
    "prerequisites": "БМА +1",
    "description": "Вы делаете широкий шаг прерывающим действием",
    "referenceUrl": "https://pathfinder.family/feat/stepUp"
  },
  "strike-back": {
    "name": "Ответный удар",
    "prerequisites": "БМА +11",
    "description": "Вы можете атаковать врагов, бьющих из-за пределов вашейзоны досягаемости",
    "referenceUrl": "https://pathfinder.family/feat/strikeBack"
  },
  "throw-anything": {
    "name": "Универсальный метатель",
    "prerequisites": "",
    "description": "Нет штрафов к атаке импровизированным метательным оружием",
    "referenceUrl": "https://pathfinder.family/feat/throwAnything"
  },
  "two-weapon-fighting": {
    "name": "Парное оружие",
    "prerequisites": "Лвк 15",
    "description": "Снижение штрафов при бое парным оружием",
    "referenceUrl": "https://pathfinder.family/feat/twoWeaponFighting"
  },
  "double-slice": {
    "name": "Сила двух рук",
    "prerequisites": "Парное оружие",
    "description": "Вы добавляете свой модификатор Силы к атакам неведущей рукой",
    "referenceUrl": "https://pathfinder.family/feat/doubleSlice"
  },
  "two-weapon-rend": {
    "name": "Двойной удар",
    "prerequisites": "Сила двух рук, Парное оружие+, БМА +11",
    "description": "Вы наносите дополнительный урон, если успешны две атаки сразу",
    "referenceUrl": "https://pathfinder.family/feat/twoWeaponRend"
  },
  "improved-two-weapon-fighting": {
    "name": "Парное оружие+",
    "prerequisites": "Парное оружие, Лвк 17, БМА +6",
    "description": "Вы способны дважды атаковать неведущей рукой",
    "referenceUrl": "https://pathfinder.family/feat/improvedTwoWeaponFighting"
  },
  "greater-two-weapon-fighting": {
    "name": "Парное оружие++",
    "prerequisites": "Парное оружие+, Лвк 19, БМА +11",
    "description": "Вы способны трижды атаковать неведущей рукой",
    "referenceUrl": "https://pathfinder.family/feat/greaterTwoWeaponFighting"
  },
  "two-weapon-defense": {
    "name": "Парное парирование",
    "prerequisites": "Парное оружие",
    "description": "Вы получаете +1 (щит) к КБ, когда деретесь парным оружием",
    "referenceUrl": "https://pathfinder.family/feat/twoWeaponDefense"
  },
  "vital-strike": {
    "name": "Жестокий удар",
    "prerequisites": "БМА +6",
    "description": "Вы наносите одной атакой двойной базовый урон",
    "referenceUrl": "https://pathfinder.family/feat/vitalStrike"
  },
  "improved-vital-strike": {
    "name": "Жестокий удар+",
    "prerequisites": "Жестокий удар, БМА +11",
    "description": "Вы наносите одной атакой тройной базовый урон",
    "referenceUrl": "https://pathfinder.family/feat/improvedVitalStrike"
  },
  "greater-vital-strike": {
    "name": "Жестокий удар++",
    "prerequisites": "Жестокий удар+, БМА +16",
    "description": "Вы наносите одной атакой четырехкратный базовый урон",
    "referenceUrl": "https://pathfinder.family/feat/greaterVitalStrike"
  },
  "weapon-finesse": {
    "name": "Фехтование",
    "prerequisites": "",
    "description": "Вы применяете модификатор Ловкости вместо Силы к атакам одноручным оружием",
    "referenceUrl": "https://pathfinder.family/feat/weaponFinesse"
  },
  "weapon-focus": {
    "name": "Уверенное владение оружием",
    "prerequisites": "Обращение с оружием, БМА +1",
    "description": "+1 к атакам выбранным оружием",
    "referenceUrl": "https://pathfinder.family/feat/weaponFocus"
  },
  "dazzling-display": {
    "name": "Демонстрация силы",
    "prerequisites": "Уверенное владение оружием",
    "description": "Вы запугиваете всех противников в радиусе 30 футов от вас",
    "referenceUrl": "https://pathfinder.family/feat/dazzlingDisplay"
  },
  "shatter-defenses": {
    "name": "Неожиданный выпад",
    "prerequisites": "Демонстрация силы, БМА +6",
    "description": "Вы застигаете врасплох противников в негативном состоянии",
    "referenceUrl": "https://pathfinder.family/feat/shatterDefenses"
  },
  "deadly-stroke": {
    "name": "Смертоносный взмах",
    "prerequisites": "Неожиданный выпад, Неожиданный выпад, БМА +11",
    "description": "Вы наносите двойной урон и вызываете кровотечение (1 пункт урона Выносливости)",
    "referenceUrl": "https://pathfinder.family/feat/deadlyStroke"
  },
  "greater-weapon-focus": {
    "name": "Уверенное владение оружием+",
    "prerequisites": "Уверенное владение оружием, 8 уровень воина",
    "description": "+1 к атакам выбранным оружием",
    "referenceUrl": "https://pathfinder.family/feat/greaterWeaponFocus"
  },
  "penetrating-strike": {
    "name": "Пронзающий удар",
    "prerequisites": "Уверенное владение оружием, 12 уровень воина",
    "description": "Вы игнорируете 5 пунктов СУ",
    "referenceUrl": "https://pathfinder.family/feat/penetratingStrike"
  },
  "greater-penetrating-strike": {
    "name": "Пронзающий удар+",
    "prerequisites": "Пронзающий удар, 16 уровень воина",
    "description": "Вы игнорируете 10 пунктов СУ",
    "referenceUrl": "https://pathfinder.family/feat/greaterPenetratingStrike"
  },
  "weapon-specialization": {
    "name": "Привычное оружие",
    "prerequisites": "Уверенное владение оружием, 4 уровень воина",
    "description": "+2 к урону одним видом оружия",
    "referenceUrl": "https://pathfinder.family/feat/weaponSpecialization"
  },
  "greater-weapon-specialization": {
    "name": "Привычное оружие+",
    "prerequisites": "Привычное оружие, 12 уровень воина",
    "description": "+2 к урону одним видом оружия",
    "referenceUrl": "https://pathfinder.family/feat/greaterWeaponSpecialization"
  },
  "acrobatic": {
    "name": "Акробат",
    "prerequisites": "",
    "description": "+2 к проверкам Акробатики и Полета",
    "referenceUrl": "https://pathfinder.family/feat/acrobatic"
  },
  "alertness": {
    "name": "Бдительность",
    "prerequisites": "",
    "description": "+2 к проверкам Внимания и Проницательности",
    "referenceUrl": "https://pathfinder.family/feat/alertness"
  },
  "alignment-channel": {
    "name": "Проводник мировоззрения",
    "prerequisites": "Классовая особенность, позволяющая проводить энергию",
    "description": "Вы лечите или наносите урон потусторонним существам с помощью энергии",
    "referenceUrl": "https://pathfinder.family/feat/alignmentChannel"
  },
  "animal-affinity": {
    "name": "Друг животных",
    "prerequisites": "",
    "description": "+2 к проверкам Дрессировки и Верховой езды",
    "referenceUrl": "https://pathfinder.family/feat/animalAffinity"
  },
  "athletic": {
    "name": "Атлет",
    "prerequisites": "",
    "description": "+2 к проверкам Лазания и Плавания",
    "referenceUrl": "https://pathfinder.family/feat/athletic"
  },
  "augment-summoning": {
    "name": "Усиленный призыв",
    "prerequisites": "Любимая школа магии (школа воплощения)",
    "description": "Призванные существа получают +4 к Силе и Выносливости",
    "referenceUrl": "https://pathfinder.family/feat/augmentSummoning"
  },
  "combat-casting": {
    "name": "Боевая магия",
    "prerequisites": "",
    "description": "+4 к концентрации при оборонительном сотворении заклинаний",
    "referenceUrl": "https://pathfinder.family/feat/combatCasting"
  },
  "command-undead": {
    "name": "Подчинение нежити",
    "prerequisites": "Классовая особенность, позволяющая проводить негативную энергию",
    "description": "Подчинение нежити с помощью негативной энергии",
    "referenceUrl": "https://pathfinder.family/feat/commandUndead"
  },
  "deceitful": {
    "name": "Обманщик",
    "prerequisites": "",
    "description": "+ 2 к проверкам Блефа и Маскировки",
    "referenceUrl": "https://pathfinder.family/feat/deceitful"
  },
  "deft-hands": {
    "name": "Легкая рука",
    "prerequisites": "",
    "description": "+2 к проверкам Механики и Ловкости рук",
    "referenceUrl": "https://pathfinder.family/feat/deftHands"
  },
  "elemental-channel": {
    "name": "Проводник энергии стихий",
    "prerequisites": "Классовая особенность, позволяющая проводить энергию",
    "description": "Вы лечите элементалей или наносите им урон проводимой энергией",
    "referenceUrl": "https://pathfinder.family/feat/elementalChannel"
  },
  "endurance": {
    "name": "Двужильный",
    "prerequisites": "",
    "description": "+4 к попыткам избежать несмертельного урона",
    "referenceUrl": "https://pathfinder.family/feat/endurance"
  },
  "diehard": {
    "name": "Крепкий орешек",
    "prerequisites": "Двужильный",
    "description": "Стабилизация и сохранение сознания при отрицательных ПЗ",
    "referenceUrl": "https://pathfinder.family/feat/diehard"
  },
  "eschew-materials": {
    "name": "Заклинания без реагентов",
    "prerequisites": "",
    "description": "Сотворение заклинаний без материальных компонентов",
    "referenceUrl": "https://pathfinder.family/feat/eschewMaterials"
  },
  "extra-channel": {
    "name": "Дополнительная божественная сила",
    "prerequisites": "Классовая особенность, позволяющая проводить энергию",
    "description": "Вы можете проводить энергию еще 2 раза в день",
    "referenceUrl": "https://pathfinder.family/feat/extraChannel"
  },
  "extra-ki": {
    "name": "Дополнительная ци",
    "prerequisites": "Классовая особенность запас ци",
    "description": "Увеличивает запас ци на 2 пункта",
    "referenceUrl": "https://pathfinder.family/feat/extraKi"
  },
  "extra-lay-on-hands": {
    "name": "Дополнительные возложения рук",
    "prerequisites": "Классовая особенность возложение рук",
    "description": "Вы можете использовать возложение рук еще 2 раза в день",
    "referenceUrl": "https://pathfinder.family/feat/extraLayOnHands"
  },
  "extra-mercy": {
    "name": "Дополнительные избавления",
    "prerequisites": "Классовая особенность избавление",
    "description": "При возложении рук вы творите дополнительно еще одно избавление",
    "referenceUrl": "https://pathfinder.family/feat/extraMercy"
  },
  "extra-performance": {
    "name": "Дополнительные выступления",
    "prerequisites": "Классовая особенность выступление барда",
    "description": "Еще 6 раундов выступления барда в день",
    "referenceUrl": "https://pathfinder.family/feat/extraPerformance"
  },
  "extra-rage": {
    "name": "Длительная ярость",
    "prerequisites": "Классовая особенность ярость",
    "description": "Еще 6 раундов ярости в день",
    "referenceUrl": "https://pathfinder.family/feat/extraRage"
  },
  "fleet": {
    "name": "Быстроногий",
    "prerequisites": "",
    "description": "Базовая скорость на 5 футов выше",
    "referenceUrl": "https://pathfinder.family/feat/fleet"
  },
  "great-fortitude": {
    "name": "Внушительная стойкость",
    "prerequisites": "",
    "description": "+2 к испытаниям Стойкости",
    "referenceUrl": "https://pathfinder.family/feat/greatFortitude"
  },
  "improved-great-fortitude": {
    "name": "Внушительная стойкость+",
    "prerequisites": "Внушительная стойкость",
    "description": "Переброс испытания Стойкости раз в день",
    "referenceUrl": "https://pathfinder.family/feat/improvedGreatFortitude"
  },
  "improved-channel": {
    "name": "Великая божественная сила",
    "prerequisites": "Классовая особенность,позволяющая проводить энергию",
    "description": "+2 к СЛ испытаний против проводимой вами энергии",
    "referenceUrl": "https://pathfinder.family/feat/improvedChannel"
  },
  "improved-counterspell": {
    "name": "Мастер контрзаклинаний",
    "prerequisites": "",
    "description": "Вы творите контрзаклинания чарами той же школы",
    "referenceUrl": "https://pathfinder.family/feat/improvedCounterspell"
  },
  "improved-familiar": {
    "name": "Улучшенный фамильяр",
    "prerequisites": "Способность иметь фамильяра",
    "description": "Более сильный фамильяр",
    "referenceUrl": "https://pathfinder.family/feat/improvedFamiliar"
  },
  "iron-will": {
    "name": "Стальная воля",
    "prerequisites": "",
    "description": "+2 к испытаниям Воли",
    "referenceUrl": "https://pathfinder.family/feat/ironWill"
  },
  "improved-iron-will": {
    "name": "Стальная воля+",
    "prerequisites": "Стальная воля",
    "description": "Переброс испытания Воли один раз в день",
    "referenceUrl": "https://pathfinder.family/feat/improvedIronWill"
  },
  "leadership": {
    "name": "Лидерство",
    "prerequisites": "Уровень персонажа 7",
    "description": "У вас появляеются соратник и последователи",
    "referenceUrl": "https://pathfinder.family/feat/leadership"
  },
  "lightning-reflexes": {
    "name": "Молниеносная реакция",
    "prerequisites": "",
    "description": "+2 к испытаниям Реакции",
    "referenceUrl": "https://pathfinder.family/feat/lightningReflexes"
  },
  "improved-lightning-reflexes": {
    "name": "Молниеносная реакция+",
    "prerequisites": "Молниеносная реакция",
    "description": "Один переброс испытания Реакции в день",
    "referenceUrl": "https://pathfinder.family/feat/improvedLightningReflexes"
  },
  "magical-aptitude": {
    "name": "Предрасположенность к магии",
    "prerequisites": "",
    "description": "+2 к проверкам Колдовства и Использования магических устройств",
    "referenceUrl": "https://pathfinder.family/feat/magicalAptitude"
  },
  "master-craftsman": {
    "name": "Мастер-ремесленник",
    "prerequisites": "5 пунктов в Ремесле или Профессии",
    "description": "Вы создаете волшебные предметы, не будучи заклинателем",
    "referenceUrl": "https://pathfinder.family/feat/masterCraftsman"
  },
  "natural-spell": {
    "name": "Природная магия",
    "prerequisites": "Мдр 13, классовая особенность природный облик",
    "description": "Способность творить заклинания в природном облике",
    "referenceUrl": "https://pathfinder.family/feat/naturalSpell"
  },
  "persuasive": {
    "name": "Убедительность",
    "prerequisites": "",
    "description": "+2 к проверкам Дипломатии и Запугивания",
    "referenceUrl": "https://pathfinder.family/feat/persuasive"
  },
  "run": {
    "name": "Бегун",
    "prerequisites": "",
    "description": "Скорость бега в 5 раз выше базовой",
    "referenceUrl": "https://pathfinder.family/feat/run"
  },
  "selective-channeling": {
    "name": "Избирательная божественная сила",
    "prerequisites": "Хар 13, классовая особенность, позволяющая проводить энергию",
    "description": "Вы выбираете на кого подействует проводимая вами энергия",
    "referenceUrl": "https://pathfinder.family/feat/selectiveChanneling"
  },
  "self-sufficient": {
    "name": "Самодостаточность",
    "prerequisites": "",
    "description": "+2 к проверкам Лечения и Выживания",
    "referenceUrl": "https://pathfinder.family/feat/selfSufficient"
  },
  "skill-focus": {
    "name": "Эксперт",
    "prerequisites": "",
    "description": "+3 к проверкам одного навыка (+6 при 10 пунктах)",
    "referenceUrl": "https://pathfinder.family/feat/skillFocus"
  },
  "spell-focus": {
    "name": "Любимая школа магии",
    "prerequisites": "",
    "description": "+1 к сложности испытаний против чар одной школы",
    "referenceUrl": "https://pathfinder.family/feat/spellFocus"
  },
  "greater-spell-focus": {
    "name": "Любимая школа магии+",
    "prerequisites": "Любимая школа магии",
    "description": "+1 к сложности испытаний против чар одной школы",
    "referenceUrl": "https://pathfinder.family/feat/greaterSpellFocus"
  },
  "spell-mastery": {
    "name": "Вызубренные заклинания",
    "prerequisites": "1 уровень волшебника",
    "description": "Вы можете подготавливать некоторые заклинания без книги",
    "referenceUrl": "https://pathfinder.family/feat/spellMastery"
  },
  "spell-penetration": {
    "name": "Преодолевающая магия",
    "prerequisites": "",
    "description": "+2 к проверкам УЗ для преодоления УкМ",
    "referenceUrl": "https://pathfinder.family/feat/spellPenetration"
  },
  "greater-spell-penetration": {
    "name": "Преодолевающая магия+",
    "prerequisites": "Преодолевающая магия",
    "description": "+2 к проверкам УЗ для преодоления УкМ",
    "referenceUrl": "https://pathfinder.family/feat/greaterSpellPenetration"
  },
  "stealthy": {
    "name": "Проныра",
    "prerequisites": "",
    "description": "+2 к проверкам Изворотливости и Скрытности",
    "referenceUrl": "https://pathfinder.family/feat/stealthy"
  },
  "toughness": {
    "name": "Живучесть",
    "prerequisites": "",
    "description": "+3 ПЗ, +1 ПЗ за каждую КЗ после третьей",
    "referenceUrl": "https://pathfinder.family/feat/toughness"
  },
  "turn-undead": {
    "name": "Изгнание нежити",
    "prerequisites": "Классовая особенность, позволяющая проводить позитивную энергию",
    "description": "Вы можете обращать нежить в бегство",
    "referenceUrl": "https://pathfinder.family/feat/turnUndead"
  },
  "brew-potion": {
    "name": "Создание зелий",
    "prerequisites": "УЗ 3",
    "description": "Позволяет создавать волшебные зелья",
    "referenceUrl": "https://pathfinder.family/feat/brewPotion"
  },
  "craft-magic-arms-and-armor": {
    "name": "Создание волшебного оружия и доспехов",
    "prerequisites": "УЗ 5",
    "description": "Позволяет создавать волшебные доспехи, щиты и оружие",
    "referenceUrl": "https://pathfinder.family/feat/craftMagicArmsAndArmor"
  },
  "craft-rod": {
    "name": "Создание скипетров",
    "prerequisites": "УЗ 9",
    "description": "Позволяет создавать волшебные скипетры",
    "referenceUrl": "https://pathfinder.family/feat/craftRod"
  },
  "craft-staff": {
    "name": "Создание посохов",
    "prerequisites": "УЗ 11",
    "description": "Позволяет создавать волшебные посохи",
    "referenceUrl": "https://pathfinder.family/feat/craftStaff"
  },
  "craft-wand": {
    "name": "Создание жезлов",
    "prerequisites": "УЗ 5",
    "description": "Позволяет создавать волшебные жезлы",
    "referenceUrl": "https://pathfinder.family/feat/craftWand"
  },
  "craft-wondrous-item": {
    "name": "Создание волшебных вещиц",
    "prerequisites": "УЗ 3",
    "description": "Позволяет создавать волшебные вещицы",
    "referenceUrl": "https://pathfinder.family/feat/craftWondrousItem"
  },
  "forge-ring": {
    "name": "Создание колец",
    "prerequisites": "УЗ 7",
    "description": "Позволяет создавать волшебные кольца",
    "referenceUrl": "https://pathfinder.family/feat/forgeRing"
  },
  "scribe-scroll": {
    "name": "Написание свитков",
    "prerequisites": "УЗ 1",
    "description": "Позволяет создавать волшебные свитки",
    "referenceUrl": "https://pathfinder.family/feat/scribeScroll"
  },
  "empower-spell": {
    "name": "Мощное заклинание",
    "prerequisites": "",
    "description": "Переменные в заклинании увеличиваются на 50%",
    "referenceUrl": "https://pathfinder.family/feat/empowerSpell"
  },
  "enlarge-spell": {
    "name": "Дальнобойное заклинание",
    "prerequisites": "",
    "description": "Дистанция заклинания удваивается",
    "referenceUrl": "https://pathfinder.family/feat/enlargeSpell"
  },
  "extend-spell": {
    "name": "Длительное заклинание",
    "prerequisites": "",
    "description": "Длительность заклинания удваивается",
    "referenceUrl": "https://pathfinder.family/feat/extendSpell"
  },
  "heighten-spell": {
    "name": "Повышенное заклинание",
    "prerequisites": "",
    "description": "Круг заклинания повышается",
    "referenceUrl": "https://pathfinder.family/feat/heightenSpell"
  },
  "maximize-spell": {
    "name": "Максимизированное заклинание",
    "prerequisites": "",
    "description": "Переменные в заклинании имеют максимальные значения",
    "referenceUrl": "https://pathfinder.family/feat/maximizeSpell"
  },
  "quicken-spell": {
    "name": "Быстрое заклинание",
    "prerequisites": "",
    "description": "Сотворение заклинания - быстрое действие",
    "referenceUrl": "https://pathfinder.family/feat/quickenSpell"
  },
  "silent-spell": {
    "name": "Безмолвное заклинание",
    "prerequisites": "",
    "description": "Сотворение заклинания без словесного компонента",
    "referenceUrl": "https://pathfinder.family/feat/silentSpell"
  },
  "still-spell": {
    "name": "Безжестовое заклинание",
    "prerequisites": "",
    "description": "Сотворение заклинания без жестового компонента",
    "referenceUrl": "https://pathfinder.family/feat/stillSpell"
  },
  "widen-spell": {
    "name": "Обширное заклинание",
    "prerequisites": "",
    "description": "Область заклинания удваивается",
    "referenceUrl": "https://pathfinder.family/feat/widenSpell"
  }
};

const slug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
const RUSSIAN_CATEGORIES = {
  Combat: "Боевая",
  General: "Общая",
  "Item Creation": "Создание предметов",
  Metamagic: "Метамагия",
};
const makeFeat = (name, category) => ({
  id: slug(name),
  name: { ru: LOCALIZED_FEATS[slug(name)].name, en: name },
  category: { ru: RUSSIAN_CATEGORIES[category], en: category },
  source: SOURCE,
  prerequisites: { ru: LOCALIZED_FEATS[slug(name)].prerequisites, en: DETAILS[name]?.prerequisites ?? "See source" },
  description: { ru: LOCALIZED_FEATS[slug(name)].description, en: DETAILS[name]?.description ?? "Core Rulebook feat. See source for the complete effect and prerequisites." },
  referenceUrls: {
    ru: LOCALIZED_FEATS[slug(name)].referenceUrl,
    en: `${ENGLISH_REFERENCE_URL}?ItemName=${encodeURIComponent(name)}`,
  },
});

export const CORE_FEATS = [
  ...COMBAT_FEATS.map((name) => makeFeat(name, "Combat")),
  ...GENERAL_FEATS.map((name) => makeFeat(name, "General")),
  ...ITEM_CREATION_FEATS.map((name) => makeFeat(name, "Item Creation")),
  ...METAMAGIC_FEATS.map((name) => makeFeat(name, "Metamagic")),
].sort((left, right) => left.name.ru.localeCompare(right.name.ru, "ru"));
